<style lang="scss" src='./Sensors.scss' scoped></style>
<template src="./Sensors.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GwExport from '@/components/gwExport/GwExport.vue';
import ApexChart from 'vue-apexcharts';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';
import SensorDetails from '@/views/sensors/details/SensorDetails.vue';
import { mapState } from 'vuex';
import XLSX from 'xlsx';

import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import {
    getSensorsReportFilters,
    getSensorsReportList,
    getSensorsReportGraphData,
    getSensorGraph
} from '@/api/index';

import i18n from './../../../../i18n';
import { filter } from 'vuedraggable';

let CounterForUpdatesCol = 0; 
let CounterForUpdatesLines = 0;
let sensorsArray = [];
let allReadingsArray = [];

const perPage = 100;
const pdfMaxWidth = 1120;
const chartWidth12 = "1050px";
const chartWidth8 = "700px";
const chartWidth6 = "500px";
const chartWidth4 = "350px";

const colorsArray = [
                    '#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800',
                    "#63b598", "#ce7d78", "#ea9e70", "#a48a9e", "#c6e1e8", "#648177" ,"#0d5ac1" ,
                    "#f205e6" ,"#1c0365" ,"#14a9ad" ,"#4ca2f9" ,"#a4e43f" ,"#d298e2" ,"#6119d0",
                    "#d2737d" ,"#c0a43c" ,"#f2510e" ,"#651be6" ,"#79806e" ,"#61da5e" ,"#cd2f00" ,
                    "#9348af" ,"#01ac53" ,"#c5a4fb" ,"#996635","#b11573" ,"#4bb473" ,"#75d89e" ,
                    "#2f3f94" ,"#2f7b99" ,"#da967d" ,"#34891f" ,"#b0d87b" ,"#ca4751" ,"#7e50a8" ,
                    "#c4d647" ,"#e0eeb8" ,"#11dec1" ,"#289812" ,"#566ca0" ,"#ffdbe1" ,"#2f1179" ,
                    "#935b6d" ,"#916988" ,"#513d98" ,"#aead3a", "#9e6d71", "#4b5bdc", "#0cd36d",
                    "#250662", "#cb5bea", "#228916", "#ac3e1b", "#df514a", "#539397", "#880977",
                    "#f697c1", "#ba96ce", "#679c9d", "#c6c42c", "#5d2c52", "#48b41b", "#e1cf3b",
                    "#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf",
                    "#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234",
                    "#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158",
                    "#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647",
                    "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
                    "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
                    "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#21538e", "#89d534", "#d36647",
                    "#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
                    "#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
                    "#1bb699", "#6b2e5f", "#64820f", "#1c271", "#9cb64a", "#996c48", "#9ab9b7",
                    "#06e052", "#e3a481", "#0eb621", "#fc458e", "#b2db15", "#aa226d", "#792ed8",
                    "#73872a", "#520d3a", "#cefcb8", "#a5b3d9", "#7d1d85", "#c4fd57", "#f1ae16",
                    "#8fe22a", "#ef6e3c", "#243eeb", "#1dc18", "#dd93fd", "#3f8473", "#e7dbce",
                    "#421f79", "#7a3d93", "#635f6d", "#93f2d7", "#9b5c2a", "#15b9ee", "#0f5997",
                    "#409188", "#911e20", "#1350ce", "#10e5b1", "#fff4d7", "#cb2582", "#ce00be",
                    "#32d5d6", "#17232", "#608572", "#c79bc2", "#00f87c", "#77772a", "#6995ba",
                    "#fc6b57", "#f07815", "#8fd883", "#060e27", "#96e591", "#21d52e", "#d00043",
                    "#b47162", "#1ec227", "#4f0f6f", "#1d1d58", "#947002", "#bde052", "#e08c56",
                    "#28fcfd", "#bb09b", "#36486a", "#d02e29", "#1ae6db", "#3e464c", "#a84a8f",
                    "#911e7e", "#3f16d9", "#0f525f", "#ac7c0a", "#b4c086", "#c9d730", "#30cc49",
                    "#3d6751", "#fb4c03", "#640fc1", "#62c03e", "#d3493a", "#88aa0b", "#406df9",
                    "#615af0", "#4be47", "#2a3434", "#4a543f", "#79bca0", "#a8b8d4", "#00efd4",
                    "#7ad236", "#7260d8", "#1deaa7", "#06f43a", "#823c59", "#e3d94c", "#dc1c06",
                    "#f53b2a", "#b46238", "#2dfff6", "#a82b89", "#1a8011", "#436a9f", "#1a806a",
                    "#4cf09d", "#c188a2", "#67eb4b", "#b308d3", "#fc7e41", "#af3101", "#ff065",
                    "#71b1f4", "#a2f8a5", "#e23dd0", "#d3486d", "#00f7f9", "#474893", "#3cec35",
                    "#1c65cb", "#5d1d0c", "#2d7d2a", "#ff3420", "#5cdd87", "#a259a4", "#e4ac44",
                    "#1bede6", "#8798a4", "#d7790f", "#b2c24f", "#de73c2", "#d70a9c", "#25b67",
                    "#88e9b8", "#c2b0e2", "#86e98f", "#ae90e2", "#1a806b", "#436a9e", "#0ec0ff",
                    "#f812b3", "#b17fc9", "#8d6c2f", "#d3277a", "#2ca1ae", "#9685eb", "#8a96c6",
                    "#dba2e6", "#76fc1b", "#608fa4", "#20f6ba", "#07d7f6", "#dce77a", "#77ecca"
                ];

export default {
    name: 'Sensors',
    extends: SecurityComponent,
    components: {
        ApexChart,
        VueHtml2pdf,
        GwExport,
        SensorDetails,
        Datepicker
    },
    data() {
        return {
            advancedOptions: {
                worker: true,
            },
            selectedDateRange: null,
            chartMaxWidth12: '100%',
            chartMaxWidth8: '100%',
            chartMaxWidth6: '100%',
            chartMaxWidth4: '100%',
            stickyData: true,
            isOperationsOrAdminUser : false,
            pdfName : null,
            loading: {
                general: false,
                filters: false,
                sensors: false,
                salinity: false,
                dielectric: false,
                ground_temp: false,
                moisture: false,
                rssi: false
            },
            all: false,
            all_zones: false,
            front9: false,
            back9: false,
            filters: {
                daysBack: null,
                holes: [],
                zones: []
            },
            sensors: [],
            loadedSensorsArray: [],
            allSensorsLength: 0,
            sensorsLength: 0,
            filteredSensors: [],
            column_series: [],
            column_x_cats: [],
            column_holes_series: [],
            column_x_holes_cats: [],
            dielectric_series: [],
            salinity_series: [],
            ground_temp_series: [],
            rssi_temp_series: [],
            moisture_series: [],
            zones: [],
            holes: [],
            zones_amount: {},
            holes_amount: {},
            sensorSelected : null,
            byZoneData: {},
            byHoleData: {},
            filterHoleCols: 4,
            holesMatrix : [],
            filterZoneCols: 6,
            zonesMatrix : [],
            options: [                
                { text: this.$t('timePeriods.1DLong'), label: this.$t('timePeriods.last24H'), value: 1, },
                { text: this.$t('timePeriods.2DLong'), label: this.$t('timePeriods.last2D'), value: 2, },
                { text: this.$t('timePeriods.1WLong'), label: this.$t('timePeriods.lastWeek'), value: 7, },
                { text: this.$t('timePeriods.1MLong'), label: this.$t('timePeriods.lastMonth'), value: 30, },
                { text: this.$t('timePeriods.1YLong'), label: this.$t('timePeriods.lastYear'), value: 365, },
                { text: 'By Date', label: 'By Date', value: 0, },      

            ],
            basicColCharOpt: {
                xaxis: {
                    type: 'category',
                },
            },
            basicColHolesCharOpt: {
                xaxis: {
                    type: 'category',
                },
            },
            rssiCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            groundTempCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            salinityCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            dielectricCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            moistureCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pagination: {
                page: 1,
                start: 0,
                end: 0
            },
            pdf: {},
            currentSort: 'location_code',
            currentSortOrder: 'desc',
        };
    },
    
    computed: {
        ...mapState(['course']),
        canGetNextPage(){
            return this.pagination.page * perPage < this.sensorsLength;
        },
        getFilteredSensors(){
            let series = this.getsensorsSeriesByFilters(sensorsArray);
            this.sensorsLength = series.length;
            this.sensors = series;
            return this.getSensorsByPage();
        },
        getFilteredRSSISeries(){
            return this.getsensorsSeriesByFilters(this.rssi_temp_series);
        },
        getFilteredGroundTempSeries(){
            return this.getsensorsSeriesByFilters(this.ground_temp_series);
        },
        getFilteredDielectricSeries(){
            return this.getsensorsSeriesByFilters(this.dielectric_series);
        },
        getFilteredSalinitySeries(){
            return this.getsensorsSeriesByFilters(this.salinity_series);
        },
        getFilteredMoistureSeries(){
            return this.getsensorsSeriesByFilters(this.moisture_series);
        },
        isCourseType(){
            if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
            || !this.course.facility_type){
                return true;
            }else{
                return false;
            }
        },
        allSensorsLoaded(){
            return this.loadedSensorsArray.length > 0 && this.loadedSensorsArray.length == sensorsArray.length;
        },
    },
    methods: {
        renderHoleName(hole) {
            if(hole && hole.hole_id && hole.hole_id > 0){
                return this.G_getHoleNumber({hole:hole, includeLbl:true});
            }
            if(hole && hole.name){
                return hole.name;
            }
            return '';
        },

        renderZoneName(zone) {
            if(zone && zone.hole_id && zone.hole_id > 0){
                return this.G_getZoneName({zone: zone});
            }
            if(zone && zone.name){
                return zone.name;
            }
            return '';
        },

        clearFilters(){
            this.filters.zones.forEach((s) => {
                s.selected = false;
            });
            this.filters.holes.forEach((s) => {
                s.selected = false;
            });
            this.all = false;
            this.all_zones = false;
            this.front9 = false;
            this.back9 = false;
            let series = this.getsensorsSeriesByFilters(sensorsArray);
            this.sensorsLength = series.length;
            this.sensors = series;
            this.pagination.start = 1;
            this.pagination.page = 1;
            this.pagination.end = (this.sensorsLength >= perPage) ? perPage : this.sensorsLength;
            this.options[5].value = 0 
            this.filterByDays(this.options[0]);
            this.selectedDateRange = null
        },
        getHolesFilterMatrix(){
            this.holesMatrix = [];
            if(this.filters.holes.length > 0){
                const total = this.filters.holes.length;
                
                let qty = parseInt(total / this.filterHoleCols);
                
                qty = (total % this.filterHoleCols == 0 ) ? qty : (qty + 1);

                for(var i = 0; i < qty; i++){
                    this.holesMatrix[i] = [];
                }
                
                for(var i = 0; i < qty; i++){
                    for(var j = 0; j < this.filterHoleCols; j++){
                        const index = i + (j * qty);
                        if(index < total){
                            (this.holesMatrix[i]).push(this.filters.holes[index]);
                        }
                    }
                }
            }
        },
        getZonesFilterMatrix(){
            this.zonesMatrix = [];
            if(this.filters.zones.length > 0){
                const total = this.filters.zones.length;
                
                let qty = parseInt(total / this.filterZoneCols);
                
                qty = (total % this.filterZoneCols == 0 ) ? qty : (qty + 1);

                for(var i = 0; i < this.filterZoneCols; i++){
                    this.zonesMatrix[i] = [];
                }
                
                for(var i = 0; i < this.filterZoneCols; i++){
                    for(var j = 0; j < qty; j++){
                        const index = i + (j * this.filterZoneCols);
                        if(index < total){
                            (this.zonesMatrix[i]).push(this.filters.zones[index]);
                        }
                    }
                }
            }
        },
        getsensorsSeriesByFilters(series){
            let filteredZones = this.filters.zones.filter((r) => r.selected);
            let filteredHoles = this.filters.holes.filter((r) => r.selected);

            if(filteredHoles.length == 0 && filteredZones.length == 0 && !this.all && !this.all_zones){
                return [];
            }else{
                let series1 = []
                if(filteredHoles.length == 0 || this.all){
                    series1 = series;
                }else{

                    if(this.front9){
                        filteredHoles = this.filters.holes.filter((h) => h.hole_number >= 1 && h.hole_number <= 9);
                    }else if(this.back9){
                        filteredHoles = this.filters.holes.filter((h) => h.hole_number >= 10 && h.hole_number <= 18);
                    }

                    for(var i = 0; i < series.length; i++){
                        for(var j = 0; j < filteredHoles.length; j++){
                            if(series[i].hole_id == filteredHoles[j].hole_id){
                                series1.push(series[i]);
                            }
                        }
                    }
                }
                
                if(this.all_zones){
                    let series2 = [];
                    for(var i = 0; i < series1.length; i++){
                        
                        if(series1[i].zone_id != 'NA'){
                            series2.push(series1[i]);
                        }
                        
                    }
                    return series2;

                }else if(filteredZones.length == 0){
                    return series1;
                }else{
                    let series2 = [];
                    for(var i = 0; i < series1.length; i++){
                        for(var j = 0; j < filteredZones.length; j++){
                            if(series1[i].zone_id == filteredZones[j].zone_id){
                                series2.push(series1[i]);
                            }
                        }
                    }
                    return series2;
                }
            }
        },

        getSensorsByHole(hole){
            let sensors = 0;
            if(hole && hole.hole_id && (hole.hole_id > 0 || hole.hole_id == 'NA' )){
                sensors = this.byHoleData[hole.hole_id];
            } else if(hole && hole.hole_id == -1 || hole == -2){
                sensors = sensorsArray.length;
            } else if(hole && hole.hole_id == '1-9'){
                let holes = this.filters.holes.filter((h) => h.hole_number >= 1 && h.hole_number <= 9);
                for(let i = 0; i < holes.length; i++){
                    let h = holes[i]
                    sensors += this.byHoleData[h.hole_id] ? this.byHoleData[h.hole_id] : 0;
                }
            } else if(hole && hole.hole_id == '10-18'){
                let holes = this.filters.holes.filter((h) => h.hole_number >= 10 && h.hole_number <= 18);
                for(let i = 0; i < holes.length; i++){
                    let h = holes[i]
                    sensors += this.byHoleData[h.hole_id] ? this.byHoleData[h.hole_id] : 0;
                }
            }
            return sensors ? sensors : 0;
        },

        getSensorsByZone(zone){
            let sensors = 0;
            if(zone == -2){
                for (let key in this.byZoneData) {
                    if(key != 'NA'){
                        sensors += this.byZoneData[key];
                    }
                }
            }else{
                sensors = this.byZoneData[zone.zone_id];
            }
            return sensors ? sensors : 0;
        },

        addArray(accumulator, a) {
            return accumulator + a;
        },

        checkCourseType(){
            if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
            || !this.course.facility_type){
                return true;
            }else{
                return false;
            }
        },

        showSensorDetails(sensor) {
            this.sensorSelected = sensor;
            this.sensorSelected.course_name = this.course.name
            this.$bvModal.show('md-sensor-details');
        },

        onCloseSensorDetailsModal() {
            this.sensorSelected = null;
        },

        getCsvData(){
            return [];
        },

        csvExport() {
            let csvContent = "data:text/csv;charset=utf-8,";
            let arrData = this.getCsvAllData();
            if(arrData.length > 0){
                csvContent += [
                    Object.keys(arrData[0]).join(","),
                    ...arrData.map(item => Object.values(item).join(","))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", this.pdfName + ".csv");
                link.click();
            }
        },

        xlsxExport() {
            let readings = this.getsensorsSeriesByFilters(allReadingsArray);
            if(readings.length>0){

                var new_workbook = XLSX.utils.book_new();
                let headers = [];
                let filters = this.getXLSXHeadersObj();
                headers.push(filters);

                var worksheet = XLSX.utils.json_to_sheet(headers);
                XLSX.utils.book_append_sheet(new_workbook, worksheet, "Filters");


                let data = [];
                let currentSensor = '';
                readings.forEach((item)=>{
                    let sensor = sensorsArray.find((t) => t.sensor_id == item.sensor_id);

                    if(sensor && sensor.sensor_id && item.data && item.data.length > 0){

                        let readings_array = item.data.map( (reading) => {
                            let obj = {}
                            obj[i18n.t('sensors.sensor')] = sensor.serial_number;
                            let reading_date = this.G_formatDate({date: (reading.reading_time), pretty: false});
                            obj[i18n.t('general.date')] = reading_date;
                            obj[i18n.t('general.status')] = i18n.t(sensor.status.i18n);
                            if(this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
                                let last_reading = this.G_formatDate({date: (sensor.last_reading), pretty: false});
                                obj[i18n.t('sensors.lastReading')] = last_reading;
                            }

                            let location = '';
                            if(this.checkCourseType()){
                                location = sensor.location_code;
                            }else if(!this.checkCourseType()){
                                location = this.G_getZoneName({zone: sensor.hole});
                            }

                            obj[i18n.t('sensors.location')] = location;

                            if(this.isOperationsOrAdminUser){
                                obj[i18n.t('general.signalStrength')] = (reading.rssi == undefined || reading.rssi == null) ? '' : reading.rssi < 0 ? 
                                                    this.G_getMeasurement({ val: reading.rssi,
                                                                        uom: this.consts.UOM.RSSI,
                                                                        addUnit: true, invertUOM: false }) 
                                                    : i18n.t('general.invalid');
                            }
                            let temperature = this.G_getMeasurement({ val: reading.temperature, uom: this.consts.UOM.TEMP, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.Temperature')] = temperature.replace('°', '');
                            obj[i18n.t('alerts.Salinity')] = this.G_getMeasurement({ val: reading.bulk_ec, uom: this.consts.UOM.SALINITY, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.Dielectric')] = this.G_getMeasurement({ val: reading.dielectric, uom: this.consts.UOM.DIELECTRIC, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.Moisture')] = this.G_getMeasurement({ val: reading.vwc, uom: this.consts.UOM.MOISTURE, addUnit: true, invertUOM: false })
                            return obj;
                        });

                        if(currentSensor != sensor.serial_number && data.length > 0){
                            let new_worksheet = XLSX.utils.json_to_sheet(data);
                            XLSX.utils.book_append_sheet(new_workbook, new_worksheet, currentSensor);
                            data = [];
                        }

                        currentSensor = currentSensor != sensor.serial_number ? sensor.serial_number : currentSensor;

                        if(readings_array.length > 0){
                            data = data.concat(readings_array);
                        }

                    }
                });

                if(currentSensor && data.length > 0){
                    let new_worksheet = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.book_append_sheet(new_workbook, new_worksheet, currentSensor);
                }

                XLSX.writeFile(new_workbook, this.pdfName + ".xlsx");
            }
        },

        getCsvAllData(){
            let readings = this.getsensorsSeriesByFilters(allReadingsArray);
            if(readings.length>0){
                let data = [];
                readings.forEach((item)=>{
                    let sensor = sensorsArray.find((t) => t.sensor_id == item.sensor_id);
                    if(sensor && sensor.sensor_id && item.data && item.data.length > 0){
                        let readings_array = item.data.map( (reading) => {
                            let obj = {}
                            //obj[i18n.t('general.timeFrame')] = '';
                            obj[i18n.t('reports.filters')] = '';
                            obj[i18n.t('sensors.sensor')] = sensor.serial_number;
                            let reading_date = this.G_formatDate({date: (reading.reading_time), pretty: false});
                            obj[i18n.t('general.date')] = reading_date ? reading_date.replace(/,/g, "") : reading_date;
                            obj[i18n.t('general.status')] = i18n.t(sensor.status.i18n);
                            if(this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
                                let last_reading = this.G_formatDate({date: (sensor.last_reading), pretty: false});
                                obj[i18n.t('sensors.lastReading')] = last_reading ? last_reading.replace(/,/g, "") : last_reading;
                            }

                            let location = '';
                            if(this.checkCourseType()){
                                location = sensor.location_code;
                            }else if(!this.checkCourseType()){
                                location = this.G_getZoneName({zone: sensor.hole});
                            }

                            obj[i18n.t('sensors.location')] = location ? location.replace(/,/g, "") : location;

                            if(this.isOperationsOrAdminUser){
                                obj[i18n.t('general.signalStrength')] = (reading.rssi == undefined || reading.rssi == null) ? '' : reading.rssi < 0 ? 
                                                    this.G_getMeasurement({ val: reading.rssi,
                                                                        uom: this.consts.UOM.RSSI,
                                                                        addUnit: true, invertUOM: false }) 
                                                    : i18n.t('general.invalid');
                            }
                            let temperature = this.G_getMeasurement({ val: reading.temperature, uom: this.consts.UOM.TEMP, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.Temperature')] = temperature.replace('°', '');
                            obj[i18n.t('alerts.Salinity')] = this.G_getMeasurement({ val: reading.bulk_ec, uom: this.consts.UOM.SALINITY, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.Dielectric')] = this.G_getMeasurement({ val: reading.dielectric, uom: this.consts.UOM.DIELECTRIC, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.Moisture')] = this.G_getMeasurement({ val: reading.vwc, uom: this.consts.UOM.MOISTURE, addUnit: true, invertUOM: false })
                            return obj;
                        });
                        
                        if(readings_array.length > 0){
                            data = data.concat(readings_array);
                        }
                    }
                })
                let headers = [];
                let filters = this.getHeadersObj();
                headers.push(filters);
                return [...headers, ...data];
            }
            return [];
        },

        getHeadersObj(){
            let timeFrame = this.filters.daysBack.text;
            let filters = '';
            if(this.filters.holes.length > 0){
                for(var i = 0; i < this.filters.holes.length; i++){
                    const hole = this.filters.holes[i];
                    if(hole.selected){
                        filters += (filters != '' ? '; ' : '');
                        if(this.checkCourseType()){
                            if(hole.hole_id == 'NA'){
                                filters += i18n.t('general.other');
                            }else if(hole.hole_id == '1-9' || hole.hole_id == '10-18' ){
                                filters += hole.name;
                            }else{
                                filters += this.G_getHoleNumber({hole:hole, includeLbl:true})
                            }
                        }else{
                            filters += this.G_getZoneName({zone: hole})
                        }
                    }
                }
            }

            if(this.filters.zones.length > 0){
                for(var i = 0; i < this.filters.zones.length; i++){
                    const zone = this.filters.zones[i];
                    if(zone.selected){
                        filters += (filters != '' ? '; ' : '');
                        filters += zone.name
                    }
                }
            }

            if(this.all_zones && !this.all && filters == ''){
                filters += (filters != '' ? '; ' : '');
                filters += i18n.t('reports.allZones');
            }
            
            if(filters == ''){
                filters = i18n.t('general.all');
            }

            let obj = {}
            //obj[i18n.t('general.timeFrame')] = timeFrame;
            obj[i18n.t('reports.filters')] = i18n.t('general.timeFrame') + ': ' + timeFrame + ' | ' + i18n.t('reports.filters') + ': ' + filters;
            obj[i18n.t('sensors.sensor')] = '';
            obj[i18n.t('general.date')] = '';
            obj[i18n.t('general.status')] = '';
            if(this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
                obj[i18n.t('sensors.lastReading')] = '';
            }

            obj[i18n.t('sensors.location')] = '';

            if(this.isOperationsOrAdminUser){
                obj[i18n.t('general.signalStrength')] = '';
            }
            obj[i18n.t('alerts.Temperature')] = '';
            obj[i18n.t('alerts.Salinity')] = '';
            obj[i18n.t('alerts.Dielectric')] = '';
            obj[i18n.t('alerts.Moisture')] = '';
            return obj
        },

        getXLSXHeadersObj(){
            let timeFrame = this.filters.daysBack.text;
            let filters = '';
            if(this.filters.holes.length > 0){
                for(var i = 0; i < this.filters.holes.length; i++){
                    const hole = this.filters.holes[i];
                    if(hole.selected){
                        filters += (filters != '' ? '; ' : '');
                        if(this.checkCourseType()){
                            if(hole.hole_id == 'NA'){
                                filters += i18n.t('general.other');
                            }else if(hole.hole_id == '1-9' || hole.hole_id == '10-18' ){
                                filters += hole.name;
                            }else{
                                filters += this.G_getHoleNumber({hole:hole, includeLbl:true})
                            }
                        }else{
                            filters += this.G_getZoneName({zone: hole})
                        }
                    }
                }
            }

            if(this.filters.zones.length > 0){
                for(var i = 0; i < this.filters.zones.length; i++){
                    const zone = this.filters.zones[i];
                    if(zone.selected){
                        filters += (filters != '' ? '; ' : '');
                        filters += zone.name
                    }
                }
            }

            if(this.all_zones && !this.all && filters == ''){
                filters += (filters != '' ? '; ' : '');
                filters += i18n.t('reports.allZones');
            }
            
            if(filters == ''){
                filters = i18n.t('general.all');
            }

            let obj = {}
            obj[i18n.t('general.timeFrame')] = timeFrame;
            obj[i18n.t('reports.filters')] = filters;
            return obj
        },

        selectFilter(index, type){
            if(type != 'hole'){
                this.filters.zones[index].selected = !this.filters.zones[index].selected;
            }else{
                this.filters.holes[index].selected = !this.filters.holes[index].selected;
            }
            this.onClick(null, index, type);
        },

        onClick(ev, index, type) {
            if(type != 'hole'){
                if (index == -2){
                    this.selectAllFilteredSensors(false, type);
                }else if (index > -1) {
                    this.onSelect(this.filters.zones.filter((r) => r.selected));
                } else {
                    this.selectAllFilteredSensors(ev, type);
                    if (ev) {
                        this.onSelect(this.filters.zones.map((r) => r));
                    } else {
                        this.onSelect([]);
                    }
                }
            }else{
                if (index == -2){
                    this.selectAllFilteredSensors(false, type);
                    this.back9 = false;
                    this.front9 = false;
                }else if (index > -1) {

                    if(this.filters.holes[index] && this.filters.holes[index].hole_id && this.filters.holes[index].hole_id == -1){
                        if (this.all) {
                            this.selectAllFilteredSensors(false, type);
                            this.all = false;
                            this.back9 = false;
                            this.front9 = false;
                        }else{
                            this.selectAllFilteredSensors(false, type);
                            this.filters.holes[index].selected = true;
                            this.all = true;
                            this.back9 = false;
                            this.front9 = false;
                        }
                    }else {
                        const selected = this.filters.holes[index].selected;
                        if (this.all) {
                            this.all = false;
                            let allIndex = this.filters.holes.findIndex( hole => hole.hole_id === -1 );
                            if(allIndex >= 0){
                                this.filters.holes[allIndex].selected = false;
                            }
                        }

                        if(this.front9){
                            this.front9 = false;
                            let front9Index = this.filters.holes.findIndex( hole => hole.hole_id === '1-9' );
                            this.filters.holes[front9Index].selected = false;
                        }

                        if(this.back9){
                            this.back9 = false;
                            let back9Index = this.filters.holes.findIndex( hole => hole.hole_id === '10-18' );
                            this.filters.holes[back9Index].selected = false;
                        }

                        if(this.filters.holes[index] && this.filters.holes[index].hole_id && this.filters.holes[index].hole_id == '1-9'){
                            this.selectAllFilteredSensors(false, type);
                            this.filters.holes[index].selected = selected;
                            this.front9 = selected;
                        }

                        if(this.filters.holes[index] && this.filters.holes[index].hole_id && this.filters.holes[index].hole_id == '10-18'){
                            this.selectAllFilteredSensors(false, type);
                            this.filters.holes[index].selected = selected;
                            this.back9 = selected;
                        }

                        this.onSelect(this.filters.holes.filter((r) => r.selected));
                    }
                    
                } else {
                    this.selectAllFilteredSensors(ev, type);
                    if (ev) {
                        this.onSelect(this.filters.holes.map((r) => r));
                    } else {
                        this.onSelect([]);
                    }
                }
            }
            let series = this.getsensorsSeriesByFilters(sensorsArray);
            this.sensorsLength = series.length;
            this.sensors = series;
            this.pagination.start = 1;
            this.pagination.page = 1;
            this.pagination.end = (this.sensorsLength >= perPage) ? perPage : this.sensorsLength;
        },

        onSelect(zones) {
            if (zones && zones.length) {
                    
            }
        },

        selectAllFilteredSensors(selected, type) {
            if(type != 'hole'){
                this.filters.zones.forEach((s) => {
                    s.selected = selected;
                });
            }else{
                 this.filters.holes.forEach((s) => {
                    s.selected = selected;
                });
            }
        },

        showNextPage(){
            if(this.canGetNextPage){
                this.pagination.page += 1;
                this.pagination.start += perPage;
                let newEnd = this.pagination.end + perPage;
                this.pagination.end = (this.sensorsLength >= newEnd) ? newEnd : this.sensorsLength;
            }
            this.getSensorsByPage();
        },
        
        showPrevPage(){
            if(this.pagination.page > 1){
                this.pagination.page -= 1;
                this.pagination.start -= perPage;
                this.pagination.end = this.pagination.start + perPage - 1;
            }
            this.getSensorsByPage();
        },

        getSensorsByPage(){
            return this.sensors.slice(this.pagination.start - 1, this.pagination.end);
        },

        filterByDays(daysBack) {
            this.options[5].value = 0
            if(this.filters.daysBack != daysBack && !this.loading.sensors){
                this.selectedDateRange = null;
                this.setSecondLoadingTrue();
                this.loading.general = false;
                this.resetValues();
                this.filters.daysBack = daysBack;
                this.getCourseSensors();
            }
        },

        resetValues() {
            this.dielectric_series = [];
            this.salinity_series = [];
            this.ground_temp_series = [];
            this.rssi_temp_series = [];
            this.moisture_series = [];
            this.pagination = {
                page: 1,
                next: false
            }
        },
        
        exportReport(){
            this.$refs.sensorsPDF.generatePdf();
        },

        loadData() {
            this.setLoadingTrue();
            this.loading.general = false;
            this.getFilters();
        },

        setLoadingTrue() {
            this.loading.general = true;
            this.loading.filters = true;
            this.loading.sensors = true;
            this.loading.salinity = true;
            this.loading.dielectric = true;
            this.loading.ground_temp = true;
            this.loading.moisture = true;
            this.loading.rssi = true;
        },

        setSecondLoadingTrue() {
            this.loading.general = true;
            this.loading.sensors = true;
            this.loading.salinity = true;
            this.loading.dielectric = true;
            this.loading.ground_temp = true;
            this.loading.moisture = true;
            this.loading.rssi = true;
        },

        async getFilters() {
            const data = {
                courseId: this.$store.state.course.course_id
            };

            let apiCall = getSensorsReportFilters;
            
            await apiCall(data).then((res) => {
                
                this.zones = res.zones.filter(x => !x.hidden);
                this.holes = res.holes;

                this.filters.zones = this.zones.map((s) => {
                    return {...s, ...{selected: false}};
                });
                this.filters.holes = this.holes.map((s) => {
                    return {...s, ...{selected: false}};
                });

                if(this.isCourseType && this.filters.holes.length < 18){
                    const len = this.filters.holes.length;
                    for(let i = len; i <= 18; i++){
                        this.filters.holes.push({
                            hole_id: null,
                            hole_number: i,
                            name: i18n.t('sensors.hole') + ' ' + i,
                            selected: false
                        });    
                    }
                }

                /*if(this.filters.holes.length > 1){
                    this.filters.holes.push({
                        hole_id: -1,
                        hole_number: null,
                        name: i18n.t('general.all'),
                        selected: false
                    });
                }*/

                if(this.isCourseType){
                    this.filters.holes.push({
                        hole_id: '1-9',
                        hole_number: 0,
                        name: '1 - 9',
                        selected: false
                    },
                    {
                        hole_id: '10-18',
                        hole_number: 0,
                        name: '10 - 18',
                        selected: false
                    },
                    {
                        hole_id: 'NA',
                        hole_number: null,
                        name: i18n.t('general.other'),
                        selected: false
                    });
                }

                this.getHolesFilterMatrix();
                this.getZonesFilterMatrix();
                
                this.getCourseSensors();
            });
            
            this.loading.general = false;
        },

        customSensorSort(value) {

            if (this.currentSort != 'location_code') {
                return value.sort((a, b) => {
                    const sortBy = this.currentSort;
                    if (!a[sortBy] && !b[sortBy]) {
                        return 0;
                    }
                    else if (a[sortBy] && !b[sortBy]) {
                        return -1;
                    } 
                    else if (!a[sortBy] && b[sortBy]) {
                        return 1;
                    } 
                    else {
                        if (this.currentSortOrder === "desc") {
                            return String(a[sortBy]).localeCompare(String(b[sortBy]));
                        }
                            return String(b[sortBy]).localeCompare(String(a[sortBy]));
                        }
                    return -1;
                });
            } else {
                return value.sort((a, b) => {
                    const sortBy = this.currentSort;
                    if (!a['hole_id'] && !b['hole_id']) {
                        // no hole, order by location_code
                        if (!a[sortBy] && !b[sortBy]) {
                            return 0;
                        }
                        else if (a[sortBy] && !b[sortBy]) {
                            return -1;
                        } 
                        else if (!a[sortBy] && b[sortBy]) {
                            return 1;
                        } 
                        else {
                            if (this.currentSortOrder === "desc") {
                                return String(a[sortBy]).localeCompare(String(b[sortBy]));
                            }
                                return String(b[sortBy]).localeCompare(String(a[sortBy]));
                        }
                    }
                    else if (a['hole_id'] && !b['hole_id']) {
                        return -1;
                    } 
                    else if (!a['hole_id'] && b['hole_id']) {
                        return 1;
                    } 
                    else {
                        const holeA = parseInt(a['hole']['hole_number']);
                        const holeB = parseInt(b['hole']['hole_number']);

                        if (holeA > holeB){
                            if (this.currentSortOrder === "desc") {
                                return 1;
                            }
                            return -1;
                        } else if (holeB > holeA) {
                            if (this.currentSortOrder === "desc") {
                                return -1;
                            }
                            return 1;
                        } else {
                            if (this.currentSortOrder === "desc") {
                                return String(a[sortBy]).localeCompare(String(b[sortBy]));
                            }
                            return String(b[sortBy]).localeCompare(String(a[sortBy]));
                        }
                    }
                    return -1;
                });
            }
        },

        async getCourseSensors(date) {
            
            this.loading.sensors = true;
            this.loadedSensorsArray = [];
            this.allSensorsLength = 0;
            sensorsArray = [];
            const data = {
                courseId: this.$store.state.course.course_id
            };
            
            let apiCall = getSensorsReportList;
            
            await apiCall(data).then((res) => {
                //this.loading.sensors = false;

                this.sensorsLength = res.sensors.length;
                this.allSensorsLength = res.sensors.length;

                if (res.sensors.length > 0) {
                    let sensors = this.customSensorSort(res.sensors);
                    sensorsArray = sensors.map( item => {
                        item.zone_id = item.zone_id == undefined || item.zone_id == null ? 'NA' : item.zone_id;
                        item.hole_id = item.hole_id == undefined || item.hole_id == null ? 'NA' : item.hole_id;
                        return item;
                    });

                    //generalData
                    this.getSensorReadingsData(date);
                    
                    let series = this.getsensorsSeriesByFilters(sensorsArray);
                    this.sensorsLength = series.length;
                    this.pagination.start = 1;
                    this.pagination.end = (this.sensorsLength >= perPage) ? perPage : this.sensorsLength;
                    this.sensors = series;
                    this.getSensorsByPage();

                    this.byZoneData = {}
                    this.byHoleData = {}
                    
                    for(var i = 0; i < sensorsArray.length; i++){
                        let zoneKey = sensorsArray[i].zone_id;
                        let holeKey = sensorsArray[i].hole_id;

                        if(zoneKey == undefined || zoneKey == null){
                            zoneKey = 'NA';
                        }

                        if(!(zoneKey in this.byZoneData)){
                            this.byZoneData[zoneKey] = 1;
                        }else{
                            this.byZoneData[zoneKey] += 1;
                        }

                        if(holeKey == undefined || holeKey == null){
                            holeKey = 'NA';
                        }

                        if(!(holeKey in this.byHoleData)){
                            this.byHoleData[holeKey] = 1;
                        }else{
                            this.byHoleData[holeKey] += 1;
                        }
                    }

                }else{
                    this.loading.ground_temp = false;
                    this.loading.dielectric = false;
                    this.loading.salinity = false;
                    this.loading.moisture = false;
                    this.loading.rssi = false;
                }

            });
            
            this.loading.sensors = false;
        },

        handleDateRangeChange(dates) {
            this.options[5].value = 0
            this.setSecondLoadingTrue();
            this.loading.general = false;
            this.resetValues();
            let date = null;           
            if(dates[0]){                
                const startDate = moment(dates[0]).format('YYYY-MM-DD')
                const endDate = moment(dates[1]).format('YYYY-MM-DD')
                const start = new Date(startDate);
                const end = new Date(endDate);
                const timeDiff = Math.abs(end.getTime() - start.getTime());
                const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
                this.filters.daysBack = this.options[5] 
                this.filters.daysBack.value = days
                date = {
                startDate, 
                endDate
            };
            
            }
            this.getCourseSensors(date);
            
        },

        
        async getSensorReadingsData(date) {
            
            const daysBack = this.filters.daysBack;
            
            let resample = null
            if (daysBack.value == 7) {
                resample = '30min';
            } else if (daysBack.value > 7 && daysBack.value <= 30) {
                resample = '1h';
            } else if (daysBack.value > 30) {
                resample = '8h';
            }
                
            allReadingsArray = [];
            
            
            for(let index = 0; index < sensorsArray.length; index++){
                
                let sensor = sensorsArray[index];
                
                const data = {
                    sensorId: sensor.sensor_id,
                    alias: 'all',
                    until: this.filters.daysBack.value,
                    resampleFreq: resample,
                };

                if (date){
                data['startDate'] = date.startDate
                data['endDate'] = date.endDate
                }

                let apiCall = getSensorGraph;
                
                try{
                    apiCall(data).then((res) => {
                        
                        if (daysBack == this.filters.daysBack) {
                            
                            if (res.length > 0) {

                                let sensor_id = sensor.sensor_id;
                                let serial_number = sensor.serial_number;
                                let location_code = sensor.location_code;
                                
                                allReadingsArray.push({
                                        name: serial_number,
                                        data: res,
                                        sensor_id: sensor_id,
                                        zone_id: sensor.zone_id ? sensor.zone_id : 0,
                                        hole_id: sensor.hole_id ? sensor.hole_id : 0
                                });
                                
                                if(this.isOperationsOrAdminUser){
                                    this.getRSSIData(sensor, res, daysBack);
                                }
                                this.getGroundTempData(sensor, res, daysBack);
                                this.getDielectricData(sensor, res, daysBack);
                                this.getSalinityData(sensor, res, daysBack);
                                this.getMoistureData(sensor, res, daysBack);

                            }else{
                                this.loading.salinity = false;
                                this.loading.dielectric = false;
                                this.loading.ground_temp = false;
                                this.loading.moisture = false;
                                this.loading.rssi = false;
                            }

                            this.loadedSensorsArray.push(sensor.sensor_id);
                        } else {
                            console.log('overwrite prevented for  getSensorReadingsData 1 ' + daysBack);
                        }

                    });
                } catch(e) {
                    this.loadedSensorsArray.push(sensor.sensor_id);
                }
            }
        },


        async getRSSIData(sensor, res, daysBack) {
            this.loading.rssi = true;
            
            let tempChartOptions = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'RSSI'
                });
            
            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let serial_number = sensor.serial_number;
                    
                    let filteredRSSI = (res).filter(item => parseFloat(item['rssi']) < 0);
                    
                    tempSeries = (filteredRSSI).map((item) => {

                        if(item['rssi'] < 0){
                        
                            return [
                                new Date(item.reading_time).getTime(),
                                this.G_getMeasurement({
                                    val: item['rssi'],
                                    uom: 'RSSI',
                                    addUnit: false,
                                    invertUOM: false
                                })
                            ]
                        }
                        
                    });

                    this.rssi_temp_series.push({
                        name: serial_number,
                        data: tempSeries,
                        zone_id: sensor.zone_id ? sensor.zone_id : 0,
                        hole_id: sensor.hole_id ? sensor.hole_id : 0
                    });

                }
            } else {
                console.log('overwrite prevented for  getRSSIData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.rssiCharOpt.chart) {

                tempChartOptions.yaxis.title.text = uom;
                tempChartOptions.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }
                tempChartOptions.tooltip.y.title.formatter = (seriesName) => {
                    let tempSensor = sensorsArray.find(x => x.serial_number == seriesName);
                    if(tempSensor){
                        let location_code = this.checkCourseType() ? tempSensor.location_code : this.G_getZoneName({zone: tempSensor.hole})
                        return `${seriesName} ${location_code}:`;
                    }
                    return `${seriesName}:`;
                }

                this.rssiCharOpt = tempChartOptions;
            }
            this.loading.rssi = false;
        },

        async getGroundTempData(sensor, res, daysBack) {
            this.loading.ground_temp = true;
            
            let tempChartOptions = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'TEMP'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let serial_number = sensor.serial_number;
                    
                    tempSeries = (res).map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['temperature'],
                                uom: 'TEMP',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.ground_temp_series.push({
                        name: serial_number,
                        data: tempSeries,
                        zone_id: sensor.zone_id ? sensor.zone_id : 0,
                        hole_id: sensor.hole_id ? sensor.hole_id : 0
                    });
                }
            } else {
                console.log('overwrite prevented for  getGroundTempData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.groundTempCharOpt.chart) {

                tempChartOptions.yaxis.title.text = uom;
                tempChartOptions.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }
                tempChartOptions.tooltip.y.title.formatter = (seriesName) => {
                    let tempSensor = sensorsArray.find(x => x.serial_number == seriesName);
                    if(tempSensor){
                        let location_code = this.checkCourseType() ? tempSensor.location_code : this.G_getZoneName({zone: tempSensor.hole})
                        return `${seriesName} ${location_code}:`;
                    }
                    return `${seriesName}:`;
                }

                this.groundTempCharOpt = tempChartOptions;
            }
            this.loading.ground_temp = false;
        },

        async getDielectricData(sensor, res, daysBack) {
            this.loading.dielectric = true;

            let tempChartOptions = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'DIELECTRIC'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let serial_number = sensor.serial_number;
                    
                    tempSeries = (res).map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['dielectric'],
                                uom: 'DIELECTRIC',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.dielectric_series.push({
                        name: serial_number,
                        data: tempSeries,
                        zone_id: sensor.zone_id ? sensor.zone_id : 0,
                        hole_id: sensor.hole_id ? sensor.hole_id : 0
                    });
                }
            } else {
                console.log('overwrite prevented for  getDielectricData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.dielectricCharOpt.chart) {

                tempChartOptions.yaxis.title.text = uom;
                tempChartOptions.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }
                tempChartOptions.tooltip.y.title.formatter = (seriesName) => {
                    let tempSensor = sensorsArray.find(x => x.serial_number == seriesName);
                    if(tempSensor){
                        let location_code = this.checkCourseType() ? tempSensor.location_code : this.G_getZoneName({zone: tempSensor.hole})
                        return `${seriesName} ${location_code}:`;
                    }
                    return `${seriesName}:`;
                }

                this.dielectricCharOpt = tempChartOptions;
            }
            this.loading.dielectric = false;
        },

        async getSalinityData(sensor, res, daysBack) {
            this.loading.salinity = true;
            
            let tempChartOptions = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'SALINITY'
                });
            
            if (daysBack == this.filters.daysBack) {
            
                let tempSeries = [];
                if (res.length > 0) {
                    
                    let serial_number = sensor.serial_number;
                    
                    tempSeries = (res).map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['bulk_ec'],
                                uom: 'SALINITY',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.salinity_series.push({
                        name: serial_number,
                        data: tempSeries,
                        zone_id: sensor.zone_id ? sensor.zone_id : 0,
                        hole_id: sensor.hole_id ? sensor.hole_id : 0
                    });
                }
            } else {
                console.log('overwrite prevented for  getSalinityData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.salinityCharOpt.chart) {

                tempChartOptions.yaxis.title.text = uom;
                tempChartOptions.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }
                tempChartOptions.tooltip.y.title.formatter = (seriesName) => {
                    let tempSensor = sensorsArray.find(x => x.serial_number == seriesName);
                    if(tempSensor){
                        let location_code = this.checkCourseType() ? tempSensor.location_code : this.G_getZoneName({zone: tempSensor.hole})
                        return `${seriesName} ${location_code}:`;
                    }
                    return `${seriesName}:`;
                }

                this.salinityCharOpt = tempChartOptions;
            }
            this.loading.salinity = false;
        },

        async getMoistureData(sensor, res, daysBack) {
            this.loading.moisture = true;
            
            let tempChartOptions = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'MOISTURE'
                });
            
            if (daysBack == this.filters.daysBack) {
            
                let tempSeries = [];
                if (res.length > 0) {
                    
                    let serial_number = sensor.serial_number;
                    
                    tempSeries = (res).map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['vwc'],
                                uom: 'MOISTURE',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.moisture_series.push({
                        name: serial_number,
                        data: tempSeries,
                        zone_id: sensor.zone_id ? sensor.zone_id : 0,
                        hole_id: sensor.hole_id ? sensor.hole_id : 0
                    });
                }
            } else {
                console.log('overwrite prevented for  getMoistureData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.moistureCharOpt.chart) {

                tempChartOptions.yaxis.title.text = uom;
                tempChartOptions.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }
                tempChartOptions.tooltip.y.title.formatter = (seriesName) => {
                    let tempSensor = sensorsArray.find(x => x.serial_number == seriesName);
                    if(tempSensor){
                        let location_code = this.checkCourseType() ? tempSensor.location_code : this.G_getZoneName({zone: tempSensor.hole})
                        return `${seriesName} ${location_code}:`;
                    }
                    return `${seriesName}:`;
                }

                this.moistureCharOpt = tempChartOptions;
            }
            this.loading.moisture = false;
        },

        getLinesChartOptions() {
            return {
                chart: {
                    type: 'line',
                    animations: {
                        enabled: false,
                    },

                    stacked: false,
                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesLines != 0) {
                                var elmnt = document.getElementById("chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesLines;
                        }
                    }
                },
                colors: colorsArray,
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                stroke: {
                    width: 5
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val).toFixed(2) : 0;
                        },
                    },
                    title: {
                        text: 'unitOfMeasurament'
                    },
                    min: (min) => {
                        return min
                    },
                    max: (max) => {
                        return max
                    },
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false,
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: "MMM 'yy",
                            day: 'dd MMM',
                            hour: 'h:mm TT',
                        },
                    }
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return this.G_formatDate({date: val, pretty: false});
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? `${(val).toFixed(2)}` : '';
                        },
                        title: {
                            formatter: (val) => {
                                return val;
                            }
                        }
                    }
                }
            }
        },

        async beforePDF({ html2pdf, options, pdfContent }){
            let container = this.$refs.reportContainer;
            let currentWidth = container.getBoundingClientRect().width;

            if(currentWidth >= pdfMaxWidth){
                this.chartMaxWidth12 = chartWidth12;
                this.chartMaxWidth8 = chartWidth8;
                this.chartMaxWidth6 = chartWidth6;
                this.chartMaxWidth4 = chartWidth4;
                
            }

            let date = new Date();
            this.pdf.date = moment(date).format("MM-DD-YYYY");
            this.pdf.time = this.filters.daysBack.text;
            this.pdf.filters = '';
            if(this.filters.holes.length > 0){
                for(var i = 0; i < this.filters.holes.length; i++){
                    const hole = this.filters.holes[i];
                    if(hole.selected){
                        this.pdf.filters += (this.pdf.filters != '' ? ', ' : '');
                        if(this.checkCourseType()){
                            if(hole.hole_id == 'NA'){
                                this.pdf.filters += i18n.t('general.other');
                            }else if(hole.hole_id == '1-9' || hole.hole_id == '10-18'){
                                this.pdf.filters += hole.name;
                            }else{
                                this.pdf.filters += this.G_getHoleNumber({hole:hole, includeLbl:true})
                            }
                        }else{
                            this.pdf.filters += this.G_getZoneName({zone: hole})
                        }
                    }
                }
            }

            if(this.filters.zones.length > 0){
                for(var i = 0; i < this.filters.zones.length; i++){
                    const zone = this.filters.zones[i];
                    if(zone.selected){
                        this.pdf.filters += (this.pdf.filters != '' ? ', ' : '');
                        this.pdf.filters += zone.name
                    }
                }
            }

            if(this.all_zones && !this.all && this.pdf.filters == ''){
                this.pdf.filters += (this.pdf.filters != '' ? ', ' : '');
                this.pdf.filters += i18n.t('reports.allZones');
            }
            
            if(this.pdf.filters == ''){
                this.pdf.filters = i18n.t('general.all');
            }

            this.stickyData = false;

            await html2pdf().set(options).from(pdfContent).toPdf().save();

            this.chartMaxWidth12 = "100%";
            this.chartMaxWidth8 = "100%";
            this.chartMaxWidth6 = "100%";
            this.chartMaxWidth4 = "100%";
            this.stickyData = true;
        },
    },

    created() {
        let date = new Date();
        date = moment(date).format("MM-DD-YYYY");
        this.pdfName = i18n.t('sensors.sensors') + ' ' + date;
    },

    async mounted() {
        sensorsArray = [];
        this.loadedSensorsArray = [];
        allReadingsArray = [];
        
        if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
            this.isOperationsOrAdminUser = true;
        }else{
            this.isOperationsOrAdminUser = false;
        }

        this.filters.daysBack = this.options[0];
        this.loadData();
    },
};

</script>
